import { COLOR_TERTIARY, NAV_Z_INDEX } from "../../../theme";
import styled from "@emotion/styled";

const NavBar = styled.nav<{ isExpanded: boolean }>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  min-height: 100vh;
  max-height: 100vh;
  width: ${(props) => (props.isExpanded ? "272px" : "80px")};
  background-color: ${COLOR_TERTIARY};
  transition: width 250ms ease-in-out;
  overflow: hidden;
  z-index: ${NAV_Z_INDEX};
  position: fixed;
  overflow-y: auto;
  box-shadow: 0px 4px 4px 0px #00000014;
`;

export default NavBar;
